import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { PosToastrService } from "./pos-toastr.service";

@Injectable({
  providedIn: "root",
})
export class ToastService {
  constructor(
    private toastr: ToastrService,
    public _translateService: TranslateService,
    private pos: PosToastrService
  ) {}

  success(message) {
    let x = this._translateService.instant(message);
    let p = this.pos.displayLang();
    this.toastr.success(x, this._translateService.instant("Global.success"), {
      toastClass: "toast ngx-toastr",
      closeButton: true,
      positionClass: p,
    });
  }

  info(message) {
    let x = this._translateService.instant(message);
    let p = this.pos.displayLang();
    this.toastr.info(x, this._translateService.instant("Global.info"), {
      toastClass: "toast ngx-toastr",
      closeButton: true,
      positionClass: p,
    });
  }

  error(message) {
    let x = this._translateService.instant(message);
    let p = this.pos.displayLang();
    this.toastr.error(x, this._translateService.instant("Global.err"), {
      toastClass: "toast ngx-toastr",
      closeButton: true,
      positionClass: p,
    });
  }
}
